import { GET_TRANSACTIONFEE_INFO_LOADING, TRANSACTIONFEE_DATA_SUCCESS, TRANSACTIONFEE_DATA_ERROR, GET_ALTERNATEMERCHANT_TRANSACTIONFEE_INFO_LOADING, ALTERNATEMERCHANT_TRANSACTIONFEE_DATA_SUCCESS, ALTERNATEMERCHANT_TRANSACTIONFEE_DATA_ERROR } from "../actions/actionTransactionFee";
import { apiTransactionFee } from 'api';
import { put, takeEvery } from 'redux-saga/effects';

async function fetchAsync(func, param) {
    const response = await func(param);

    if (response.ok && response.status == 200) {
        return await response.json();
    }
    else if (response.status == 204) {
        return "nocontent";
    }
    if (response.status == 400) {
        let error = await response.json();
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get transaction fee, response status: " + response.status + "\"}]}")
    }
}

function* fetchTransactionFeeData(action) {
    try {
        const data = yield fetchAsync(apiTransactionFee, action.payload)
        yield put({ type: TRANSACTIONFEE_DATA_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: TRANSACTIONFEE_DATA_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

function* fetchTransactionFeeAlternateMerchantData(action) {
    try {
        const data = yield fetchAsync(apiTransactionFee, action.payload)
        yield put({ type: ALTERNATEMERCHANT_TRANSACTIONFEE_DATA_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: ALTERNATEMERCHANT_TRANSACTIONFEE_DATA_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

export const sagaTransactionFee = [
    takeEvery(GET_TRANSACTIONFEE_INFO_LOADING, fetchTransactionFeeData),
    takeEvery(GET_ALTERNATEMERCHANT_TRANSACTIONFEE_INFO_LOADING, fetchTransactionFeeAlternateMerchantData)
];
